module.exports = __webpack_public_path__ + "img/home_kefu.143402bb.png";